import GaEvent from './GaEvent';

export default class BookingFormSubmittedGaEvent extends GaEvent {
  constructor() {
    super('booking_form_submitted');
  }
}
